import {Activity} from '@activities/models/activities.types';
import {Injectable} from '@angular/core';
import {AbstractFirestoreService} from '@shared/services/abstracts/AbstractFirestoreService';
import {AuthService} from '@shared/services/auth.service';

@Injectable()
export class TransactionsRulesActivitiesService extends AbstractFirestoreService<Activity> {

    COLLECTION = 'activities';

    constructor(authService: AuthService) {
        super(authService);
    }

    setParentPath(transactionRuleID: string): void {
        this.parentPath = `transactionsRules/${transactionRuleID}`;
    }

}
